<template>
  <section>
    <div class="search-content">
      <el-row :gutter="20">
        <el-col :span="14">
          <el-button class="search-btn" size="small" type="main" icon="el-icon-edit-outline" @click="handleExec">处理</el-button>
          <el-button class="search-btn" size="small" type="search" icon="el-icon-search" @click="handleSearchDialog">筛选</el-button>
        </el-col>
        <el-col :span="10" style="text-align: right;">
          <el-input class="search-input" size="small" placeholder="请输入企业名称" v-model="searchInfo.enterpriseName"></el-input>
          <el-button class="search-btn" size="small" type="main" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="table-content">
      <el-table
        :data="tableData"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%;margin-top:20px">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          prop="enterpriseName"
          label="企业名称"
          width="120">
        </el-table-column>
        <el-table-column
          prop="enterpriseCode"
          width="180"
          label="企业代码">
        </el-table-column>
        <el-table-column
          prop="parkName"
          label="地区/园区"
          width="180">
        </el-table-column>
        <!--<el-table-column-->
        <!--prop="organizationNames"-->
        <!--label="诉求主要涉及单位"-->
        <!--width="150">-->
        <!--</el-table-column>-->
        <el-table-column
          prop="appealType"
          label="诉求类型"
          width="80"
          :formatter="appealTypeFormatter">
        </el-table-column>
        <el-table-column
          prop="appealContent"
          label="诉求事项"
          :formatter="contentFormatter"
          width="180">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="100">
        </el-table-column>
        <el-table-column label="操作" width="360">
          <template slot-scope="scope">
            <el-button type="main" size="mini" icon="el-icon-edit-outline" @click="handleExecSingle(scope.$index, scope.row)">处理</el-button>
            <el-button type="warning" size="mini" icon="el-icon-circle-close" @click="handleAppealBack(scope.$index, scope.row)">退回</el-button>
            <el-button type="success" size="mini" icon="el-icon-view" @click="handleDetail(scope.$index, scope.row)">详情</el-button>
            <!--<el-button v-if="user.role==='admin'" type="danger" size="mini" icon="el-icon-delete-solid" @click="handleDelete(scope.$index, scope.row)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="table-page"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
    <el-dialog title="快速处理" :visible.sync="handleDeliveryInfoVisible" :close-on-click-modal="false">
      <el-form :model="handleDeliveryInfo" ref="handleInfoForm" :rules="handleDeliveryInfoRules" label-width="100px">
        <el-form-item label="接收部门：" prop="organizations">
          <el-select v-model="handleDeliveryInfo.organizations" multiple placeholder="请选择部门" @change="handleOrgChange" style="width: 100%">
            <el-option
              v-for="item in organizationList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="接收人：" prop="handleUser">
          <el-select
            v-model="handleDeliveryInfo.handleUser"
            multiple
            style="width: 100%"
            @change="handleUserSelect"
            placeholder="请选择用户">
            <el-option-group
              v-for="group in userList"
              :key="group.orgId"
              :label="group.label">
              <el-option
                v-for="item in group.options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="处理意见：" prop="comment">
          <el-input v-model="handleDeliveryInfo.comment"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDeliveryInfoVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDelivery">处 理</el-button>
      </div>
    </el-dialog>
    <el-dialog title="快速处理" :visible.sync="handleInfoVisible" :close-on-click-modal="false">
      <el-form :model="handleDealInfo" ref="handleSaveInfoForm" :rules="handleSaveInfoRules" label-width="100px">
        <el-form-item label="处理：" prop="status">
          <el-select v-model="handleDealInfo.status" placeholder="请选择处理" style="width: 100%">
            <el-option
              v-for="item in handleStatusDic"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理意见：" prop="comment">
          <el-input v-model="handleDealInfo.comment"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleInfoVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveInfo">处 理</el-button>
      </div>
    </el-dialog>
    <el-dialog title="退回" :visible.sync="handleWithdrawVisible" :close-on-click-modal="false">
      <el-form :model="handleWithdrawInfo" ref="handleWithdrawForm" :rules="handleWithdrawRules" label-width="100px">
        <el-form-item label="退回原因：" prop="comment">
          <el-input v-model="handleWithdrawInfo.comment"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleWithdrawVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleWithDraw">退 回</el-button>
      </div>
    </el-dialog>
    <el-dialog title="筛选" width="75%" :visible.sync="searchDialogVisible" :close-on-click-modal="false">
      <el-form :model="searchInfo" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业名称：">
              <el-input v-model="searchInfo.enterpriseName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="信用代码：">
              <el-input v-model="searchInfo.enterpriseCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="法定代表人：">
              <el-input v-model="searchInfo.legalPerson"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业联系人：">
              <el-input v-model="searchInfo.contactPerson"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系电话：">
              <el-input v-model="searchInfo.contact"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证：">
              <el-input v-model="searchInfo.contactIdCard"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="地区/园区：">
              <el-select
                style="width: 100%"
                v-model="searchInfo.park"
                filterable
                placeholder="请输入地区/园区" clearable>
                <el-option
                  v-for="item in parkList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="诉求类型：">
              <el-select v-model="searchInfo.appealType" placeholder="请选择" style="width:100%" clearable>
                <el-option
                  v-for="item in appealTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="searchDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSearch">搜 索</el-button>
      </div>
    </el-dialog>
    <el-dialog title="详情" width="75%" :visible.sync="handleDetailInfoVisible" :close-on-click-modal="false">
      <el-form :model="handleDetailInfo" label-width="150px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业名称：" prop="enterpriseName">
              <el-input v-model="handleDetailInfo.enterpriseName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码：" prop="enterpriseCode">
              <el-input v-model="handleDetailInfo.enterpriseCode" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="法定代表人：" prop="legalPerson">
              <el-input v-model="handleDetailInfo.legalPerson" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业联系人：" prop="contactPerson">
              <el-input v-model="handleDetailInfo.contactPerson" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="contact">
              <el-input v-model="handleDetailInfo.contact" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人身份证：" prop="contactIdCard">
              <el-input v-model="handleDetailInfo.contactIdCard" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业所在园区：" prop="parkName">
              <el-input v-model="handleDetailInfo.parkName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="诉求类型：" prop="appealType">
              <el-select v-model="handleDetailInfo.appealType" placeholder="请选择" style="width:100%" :disabled="true">
                <el-option
                  v-for="item in appealTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="诉求主要涉及单位：" prop="organizationNames">
              <el-input v-model="handleDetailInfo.organizationNames.toString()" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="诉求事项说明：" prop="appealContent">
              <el-input v-model="handleDetailInfo.appealContent" type="textarea" :rows="6" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="相关附件：">
              <div v-for="file in appealFile">
                <el-link :underline="false" type="info" :href="file.fileUrl" target="_blank">{{file.fileName}}</el-link>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="handleDetailInfo" style="border-top: 1px solid #888888;padding-top: 15px;" label-width="150px">
        <el-row :gutter="20" v-if="handleDetailInfo.status !== 'wait'">
          <el-col :span="12">
            <el-form-item label="第一环节处理人：">
              <el-input v-model="handleDetailInfo.firstName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="第一环节处理时间：">
              <el-input v-model="handleDetailInfo.deliveryTime" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="handleDetailInfo.status !== 'wait'">
          <el-col :span="24">
            <el-form-item label="第一环节处理意见：">
              <el-input v-model="handleDetailInfo.deliveryComment" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="handleDetailInfo.status === 'wait'" :gutter="20">
          <el-col :span="12">
            <el-form-item label="接收部门：" prop="organizations">
              <el-select v-model="handleDetailInfo.organizations" multiple placeholder="请选择部门" @change="handleOrgChange" style="width: 100%">
                <el-option
                  v-for="item in organizationList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="接收人：" prop="handleUser">
              <el-select
                v-model="handleDetailInfo.handleUser"
                multiple
                style="width: 100%"
                @change="handleDetailUserSelect"
                placeholder="请选择用户">
                <el-option-group
                  v-for="group in userList"
                  :key="group.orgId"
                  :label="group.label">
                  <el-option
                    v-for="item in group.options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-else>
          <el-col :span="24">
            <el-form-item label="处理：" prop="status">
              <el-select v-model="handleDetailInfo.status" placeholder="请选择处理" style="width: 100%">
                <el-option
                  v-for="item in handleStatusDic"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="处理意见：" prop="comment">
              <el-input v-model="handleDetailInfo.comment"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDetailInfoVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDetailSaveInfo">处 理</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
  import Common from '@/components/common/Common'
  import { Table } from '@/components/common/Table'
  import { enterpriseAppealList, enterpriseAppealFile, enterpriseAppealDelete, portalDictionary,portalParkList, listOrg, listOrgUser, enterpriseAppealDelivery, enterpriseAppealDeal,enterpriseAppealWithdraw,detailUser } from '@/api/restapi.js'
  export default {
    mixins: [Table],
    data() {
      return {
        user: Common.user,
        organizationList: [],
        userList: [],
        parkList: [],
        appealFile: [],
        handleStatusDic: [{
          code: 'unhandle',
          name: '不处理'
        },{
          code: 'finish',
          name: '已完成'
        }],
        handleDeliveryInfo: {
          appealIds: [],
          handleUser: '',
          organizations:'',
          comment: '',
          organizationUsers: []
        },
        handleDealInfo: {
          appealIds: [],
          status: '',
          comment: ''
        },
        handleWithdrawInfo: {
          appealIds: [],
          comment: ''
        },
        handleDetailInfo: {
          appealIds: [],
          firstName: '',
          organizationNames: ''
        },
        handleDeliveryInfoRules: {
          organizations: [
            { required: true, message: '请选择接收部门', trigger: 'change' }
          ],
          handleUser: [
            { required: true, message: '请选择接收人', trigger: 'change' }
          ],
          comment: [
            { required: true, message: '请填写处理意见', trigger: 'blur' }
          ]
        },
        handleSaveInfoRules: {
          status: [
            { required: true, message: '请选择处理', trigger: 'change' }
          ],
          comment: [
            { required: true, message: '请填写处理意见', trigger: 'blur' }
          ]
        },
        handleWithdrawRules: {
          comment: [
            { required: true, message: '请填写退回原因', trigger: 'blur' }
          ]
        },
        appealTypeList: [],
        handleDeliveryInfoVisible: false,
        handleInfoVisible: false,
        handleDetailInfoVisible: false,
        handleWithdrawVisible: false
      }
    },
    mounted () {
      portalDictionary('appeal_type').then(res => {
        if (res.data.code === 0) {
          this.appealTypeList = res.data.data
        }
      })
      listOrg(1, 99999).then(res => {
        if(res.data.code === 0){
          this.organizationList = res.data.data.list
        }
      })
      this.queryParkAsync('')
    },
    methods: {
      queryParkAsync (queryString, cb) {
        portalParkList(queryString).then(res => {
          if (res.data.code === 0) {
            let names = []
            res.data.data.list.forEach(o => {
              names.push({
                value: o.name,
                id: o.id
              })
            })
            // cb(names)
            this.parkList = names
          }
        })
      },
      getOrgName (orgId) {
        let name = ''
        this.organizationList.some(org => {
          if (org.id === orgId) {
            name = org.name
            return true
          }
        })
        return name
      },
      handleOrgChange (val) {
        listOrgUser({
          orgIds: val
        }).then(res => {
          if (res.data.code === 0) {
            this.userList = []
            res.data.data.forEach(ug => {
              this.userList.push({
                label: this.getOrgName(ug.orgId),
                orgId: ug.orgId,
                options: ug.userInfos
              })
            })
          }
        })
      },
      handleUserSelect (val) {
        this.handleDeliveryInfo.organizationUsers = []
        val.forEach(uId => {
          this.userList.forEach(ug => {
            ug.options.forEach(u => {
              if (u.id === uId) {
                this.handleDeliveryInfo.organizationUsers.push({
                  organizationId: ug.orgId,
                  userId: uId
                })
              }
            })
          })
        })
      },
      handleDetailUserSelect (val) {
        this.handleDetailInfo.organizationUsers = []
        val.forEach(uId => {
          this.userList.forEach(ug => {
            ug.options.forEach(u => {
              if (u.id === uId) {
                this.handleDetailInfo.organizationUsers.push({
                  organizationId: ug.orgId,
                  userId: uId
                })
              }
            })
          })
        })
      },
      handleDelete (col, row) {
        this.$confirm('确认要删除该记录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          enterpriseAppealDelete(row.id).then(res => {
            if (res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.searchList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败'
              })
            }
          })
        })
      },
      handleExec () {
        //待处理
        if (this.selectIds.length<=0) {
          return
        }
        if (this.tableData[0] === 'wait') {
          this.handleDeliveryInfo.appealIds = this.selectIds
          this.handleDeliveryInfo.organizations = ''
          this.handleDeliveryInfo.handleUser = ''
          this.handleDeliveryInfo.comment = ''
          this.handleDeliveryInfo.organizationUsers = []
          this.handleDeliveryInfoVisible = true
        }else {
          this.handleDealInfo.appealIds = this.selectIds
          this.handleDealInfo.status = ''
          this.handleDealInfo.comment = ''
          this.handleInfoVisible = true
        }
      },
      handleExecSingle(col, row){
        if (row.status === 'wait') {
          this.handleDeliveryInfo.appealIds = []
          this.handleDeliveryInfo.appealIds.push(row.id)
          this.handleDeliveryInfo.organizations = ''
          this.handleDeliveryInfo.handleUser = ''
          this.handleDeliveryInfo.comment = ''
          this.handleDeliveryInfo.organizationUsers = []
          this.handleDeliveryInfoVisible = true
        }else {
          this.handleDealInfo.appealIds = []
          this.handleDealInfo.appealIds.push(row.id)
          this.handleDealInfo.status = ''
          this.handleDealInfo.comment = ''
          this.handleInfoVisible = true
        }
      },
      handleAppealBack (col, row) {
        this.handleWithdrawInfo.appealIds = []
        this.handleWithdrawInfo.appealIds.push(row.id)
        this.handleWithdrawInfo.comment = ''
        this.handleWithdrawVisible = true
      },
      handleWithDraw () {
        let val = this.valForm('handleWithdrawForm')
        if (!val) {
          return
        }
        enterpriseAppealWithdraw({
          appealIds: this.handleWithdrawInfo.appealIds,
          comment: this.handleWithdrawInfo.comment
        }).then(res => {
          this.$message({
            showClose: true,
            message: '已退回',
            type: 'success'
          })
          this.handleWithdrawVisible = false
          this.searchList()
        }).catch(err => {
          this.$message({
            showClose: true,
            message: '操作失败，请重试',
            type: 'error'
          })
        })
      },
      handleDelivery () {
        let val = this.valForm('handleInfoForm')
        if (!val) {
          return
        }
        enterpriseAppealDelivery(this.handleDeliveryInfo).then(res => {
          if (res.data.code === 0) {
            this.handleDeliveryInfoVisible = false
            this.$message({
              showClose: true,
              message: '处理成功',
              type: 'success'
            })
            this.searchList()
          }
        })
      },
      handleSaveInfo () {
        let val = this.valForm('handleSaveInfoForm')
        if (!val) {
          return
        }
        this.handleDealInfo.dealType = 'opinion'
        enterpriseAppealDeal(this.handleDealInfo).then(res => {
          if (res.data.code === 0) {
            this.handleInfoVisible = false
            this.$message({
              showClose: true,
              message: '处理成功',
              type: 'success'
            })
            this.searchList()
          }
        })
      },
      handleDetail (col, row) {
        this.handleDetailInfo = Object.assign({firstName:''}, row)
        this.handleDetailInfo.appealIds = []
        this.handleDetailInfo.appealIds.push(row.id)
        if (this.handleDetailInfo.status === 'distribution') {
          this.handleDetailInfo.status = ''
        }
        this.appealFile = []
        enterpriseAppealFile(row.id).then(res => {
          if (res.data.code === 0) {
            this.appealFile = res.data.data
          }
        })
        if (this.handleDetailInfo.deliveryUser) {
          detailUser(this.handleDetailInfo.deliveryUser).then(res => {
            if (res.data.code === 0) {
              this.handleDetailInfo.firstName = res.data.data.name + '(' + res.data.data.organization + ')'
            }
          })
        }
        this.handleDetailInfoVisible = true
      },
      handleDetailSaveInfo () {
        if (this.handleDetailInfo.status === 'wait') {
          enterpriseAppealDelivery(this.handleDetailInfo).then(res => {
            if (res.data.code === 0) {
              this.handleDetailInfoVisible = false
              this.$message({
                showClose: true,
                message: '处理成功',
                type: 'success'
              })
              this.searchList()
            }
          })
        }else {
          this.handleDetailInfo.dealType = 'opinion'
          enterpriseAppealDeal(this.handleDetailInfo).then(res => {
            if (res.data.code === 0) {
              this.handleDetailInfoVisible = false
              this.$message({
                showClose: true,
                message: '处理成功',
                type: 'success'
              })
              this.searchList()
            }
          })
        }
      },
      searchMethod () {
        if (this.user.role === 'admin') {
          this.searchInfo.status = 'wait'
        }else {
          this.searchInfo.filterStatus = ['distribution']
        }
        this.searchInfo.infoType='opinion'
        return enterpriseAppealList(this.pageInfo.page,this.pageInfo.size, this.searchInfo)
      },
      addMethod () {
      },
      beforeUpdate () {
      },
      updateMethod () {
      },
      valForm (formRef) {
        let isValid = true
        this.$refs[formRef].validate((valid) => {
          if (!valid) {
            isValid = false
          }
        })
        if (!isValid) {
          this.$message({
            showClose: true,
            message: '请检查填写内容',
            type: 'error'
          })
        }
        return isValid
      },
      contentFormatter (row, col) {
        return row.appealContent.substring(0,10) + (row.appealContent.length<10?'':'...')
      },
      appealTypeFormatter (row, col) {
        let name = ''
        this.appealTypeList.forEach(a => {
          if (a.code === row.appealType) {
            name = a.name
          }
        })
        return name
      }
    }
  }
</script>
<style scoped>
  @import "../style/Table.css";
</style>



// WEBPACK FOOTER //
// src/components/EnterpriseAppeal.vue